import { Table } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const CustomMoreLink = styled(Link)`
  color: #4B555E;
  font-size: 12px;
  &:hover{
    color:#6ee6c6;
  }
`

const CustomTable = styled(Table)`
  
`

export { CustomMoreLink, CustomTable };